module.exports = __webpack_public_path__ + "img/4.104c0644.png";